var map = {
	"./ContactNotes.scss": "KdoX",
	"./constant": "QvXh",
	"./constant.js": "QvXh",
	"./images/note-cn.jpg": "FuPC",
	"./images/note-eng.jpg": "Fe8q",
	"./index": "JX/d",
	"./index.js": "JX/d",
	"./locale": "8o+C",
	"./locale.js": "8o+C",
	"./redux/actions/addContactNotes": "ayZH",
	"./redux/actions/addContactNotes.js": "ayZH",
	"./redux/actions/deleteContactNotes": "dCVY",
	"./redux/actions/deleteContactNotes.js": "dCVY",
	"./redux/actions/fetchContactNotes": "YC01",
	"./redux/actions/fetchContactNotes.js": "YC01",
	"./redux/actions/updateContactNotes": "Radp",
	"./redux/actions/updateContactNotes.js": "Radp",
	"./redux/reducer": "vA13",
	"./redux/reducer.js": "vA13",
	"./style.scss": "sCQd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;



//////////////////
// WEBPACK FOOTER
// ./src/template/Docks/ContactInfo/ContactNotes ^\.\/.*$
// module id = 10
// module chunks = 0